import {
    Container,
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import RedemptionSection from "../../sections/event/RedemptionSection";
import CapsuleRedemption from "../../sections/event/CapsuleRedemption";

export default function TestRedemptionSection() {
    const { t } = useTranslation();

    let lang = getLang();


    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">TestRedemptionSection</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                </Box>
                {/* <RedemptionSection /> */}
                <CapsuleRedemption />
                
            </Stack>
        </Container>
    )
}
